import { PERMISSIONS_URL } from '@constants';
import { EnumLangs, IEditPermissionBody } from '@types';
import { errorHandler, getStorageItem } from 'helpers';
import { HttpService } from 'services';

import { globalSlice } from '../global';
import { AppDispatch } from '../index';
import { permissionsSlice } from './permissionsSlice';

const getPermissions = () => {
    const { setIsError, setIsLoading } = globalSlice.actions;
    const { setPermissions } = permissionsSlice.actions;

    const lang = getStorageItem('lang') || EnumLangs.HY;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            const url = `${PERMISSIONS_URL}?page=0&limit=100&translation=${lang}`;

            const { data } = await HttpService({
                url,
            });

            dispatch(setIsError(false));
            dispatch(setPermissions(data));
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const editPermission = (updatePermissions: IEditPermissionBody[]) => {
    const { setSnackbar, setIsLoading } = globalSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            await HttpService({
                url: PERMISSIONS_URL,
                method: 'POST',
                body: { updatePermissions },
            });

            dispatch(
                setSnackbar({
                    open: true,
                    message: 'saved',
                    variant: 'success',
                }),
            );
            dispatch(getPermissions());
            return true;
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

export const permissionsOp = {
    getPermissions,
    editPermission,
};
